module.exports = __webpack_public_path__ + "840e97b0ddfcccc3c6f998aa66853356.pdf";